// extracted by mini-css-extract-plugin
export var select = "_p0-0";